module.exports = require("prismjs/components/prism-python.js");